module.exports = __webpack_public_path__ + "static/media/overpass-heavy.196bf61d.ttf";